import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ReferenceService } from 'app/services/models/reference.service';
import { UnitTypeService } from 'app/services/models/unit-type.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-reference-transactions',
  templateUrl: './reference-transactions.component.html',
  styleUrls: ['./reference-transactions.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ReferenceTransactionsComponent implements OnInit {
  @Input() referenceId;
  referenceForm: FormGroup;

  constructor(
    public ngbModal: NgbActiveModal,
    private toastServices: ToastrService,
    private unitTypeService: UnitTypeService,
    private fb: FormBuilder,
    private referenceService: ReferenceService
  ) {

    this.referenceForm = this.fb.group({
      min: [null, Validators.required],
      max: [null, Validators.required],
      unitTypeId: [null, Validators.required],
    });
  }

  unitTypes: any[] = [];
  async ngOnInit() {
    if(this.referenceId){
      this.getByIdReference(this.referenceId);
    }
    await this.getAllUnitTypes(this.searchValue);
  }

  async getByIdReference(id){
    const data = await this.referenceService.getByIdReference(id);
    console.log(data);
    if(data){
      this.referenceForm.patchValue({
        min:data.min,
        max:data.max,
        unitTypeId:data.unitTypeId
      })
    }
  }

  searchValue = '';
  async getAllUnitTypes(search) {
    console.log(search.term);
    this.searchValue = search.term ?? this.searchValue;
    const data = await this.unitTypeService.getAllUnitType(0, 50, this.searchValue);
    console.log(data);
    this.unitTypes = data.unitTypes
  }

  closeModal() {
    this.ngbModal.close('Modal Kapatıldı.');
  }

  async onSubmit() {
    const formData = { ...this.referenceForm.value };  // Form verilerini al
    if (this.referenceId) {
      formData.id = this.referenceId;  // referenceId'yi form verilerine ekle
      const data = await this.referenceService.updateReference(formData);
      if (data.status) {
        this.toastServices.success(data.message);
        this.referenceService.sendEvent(true);
        this.closeModal();
      } else {
        this.toastServices.error(data.message);
      }
    } else {
      const data = await this.referenceService.createReference(formData);
      if (data.status) {
        this.toastServices.success(data.message);
        this.referenceService.sendEvent(true);
        this.closeModal();
      } else {
        this.toastServices.error(data.message);
      }
    }
    console.log(formData);
  }
}
